import React from "react";

interface ModalEndGameProps {
  index: number;
}

export const ModalEndGame = (props: ModalEndGameProps) => {
  const getPlanetStatus = () => {
    if (props.index >= 75) {
      return {
        message: "Bravo, votre planète est en parfait état!",
        color: "text-green-600",
        emoji: "🌍",
      };
    } else if (props.index >= 50) {
      return {
        message: "Votre planète est en assez bon état.",
        color: "text-blue-500",
        emoji: "🌎",
      };
    } else if (props.index >= 25) {
      return {
        message: "Votre planète est en mauvais état.",
        color: "text-yellow-500",
        emoji: "💔",
      };
    } else {
      return {
        message: "Votre planète est en très mauvais état.",
        color: "text-red-600",
        emoji: "💔",
      };
    }
  };

  const { message, color, emoji } = getPlanetStatus();

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10">
      <div className="absolute w-screen h-screen bg-gray-500 opacity-50 z-10"></div>
      <div className="relative w-[70vw] h-[70vh] shadow rounded-lg bg-white z-20 p-10 flex flex-col justify-between">
        <div className="w-full h-full">
          <h2 className="text-3xl border-b p-2 ">My Little Planet</h2>
          <div className="w-full h-full flex items-center justify-center gap-2">
            <div className="w-full h-full flex items-center justify-center gap-2">
              <p className={`text-xl font-bold ${color}`}>
                {message} {emoji}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
